// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"873e25e704f80c11","1221":"3d395d2baa239901","4937":"3295b8926d0f566d","7547":"f930955b5f9540da","8486":"79f4680018f7d77c"}[chunkId] + ".css";
};